"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewMotorplanModalComponent = void 0;
var core_1 = require("@angular/core");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var platform_browser_1 = require("@angular/platform-browser");
var RenewMotorplanModalComponent = /** @class */ (function () {
    function RenewMotorplanModalComponent(activeModal, sanitizer) {
        this.activeModal = activeModal;
        this.sanitizer = sanitizer;
        this.motorPlanHost = process.env.motorplan_host;
    }
    RenewMotorplanModalComponent.prototype.ngOnInit = function () {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("https://motorplan.bmw.co.za/mp3/mp3olr/servlet/BMWOcMotorplan?origin=bmwoc&VehicleID=" + this.vehicleMotorplan.vehicleInfo.bodyNumber + "&DealerCode=" + this.vehicleMotorplan.vehicleInfo.bpDealer);
        // this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.motorPlanHost+"/mp3/mp3olr/servlet/BMWOcMotorplan?origin=bmwoc&VehicleID="+this.vehicleMotorplan.vehicleInfo.bodyNumber+"&DealerCode="+this.vehicleMotorplan.vehicleInfo.bpDealer);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], RenewMotorplanModalComponent.prototype, "my_modal_title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], RenewMotorplanModalComponent.prototype, "vehicleMotorplan", void 0);
    RenewMotorplanModalComponent = __decorate([
        core_1.Component({
            selector: 'renewmotorplanmodal',
            template: require('./renewmotorplanmodal.component.html')
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
            platform_browser_1.DomSanitizer])
    ], RenewMotorplanModalComponent);
    return RenewMotorplanModalComponent;
}());
exports.RenewMotorplanModalComponent = RenewMotorplanModalComponent;
